import { render, staticRenderFns } from "./ProveedorModal.vue?vue&type=template&id=a145ebe6&"
import script from "./ProveedorModal.vue?vue&type=script&lang=js&"
export * from "./ProveedorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports